export function hexToRgb(hex) {
    return {
        r: parseInt("0x" + hex.slice(1, 3)),
        g: parseInt("0x" + hex.slice(3, 5)),
        b: parseInt("0x" + hex.slice(5, 7)),
    }
}

export function isLightColor(rgb) {
    return ((0.213 * rgb.r + 0.715 * rgb.g + 0.072 * rgb.b) > 255 / 2);
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/utils/color.ts